module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "duplicateMovements"
    }
  }, [_c('div', {
    staticClass: "row pt-5"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('analiseDuplicidade.labels.camposAvaliados.titulo'))
    }
  }), _vm._l((_vm.comparableFieldsList), function(status, idx) {
    return _c('div', [_c('div', {
      staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.checked),
        expression: "status.checked"
      }],
      attrs: {
        "id": status.id,
        "type": "checkbox",
        "name": "status"
      },
      domProps: {
        "checked": Array.isArray(status.checked) ? _vm._i(status.checked, null) > -1 : (status.checked)
      },
      on: {
        "change": function($event) {
          var $$a = status.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(status, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(status, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(status, "checked", $$c)
          }
        }
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": status.id
      }
    }, [_vm._v(_vm._s(status.nome))])])])
  })], 2)]), _c('div', {
    staticClass: "row row-filter-small mr-0 pb-5"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.buscar'),
      "id": "btnBuscarDuplicado",
      "clickFunction": _vm.validate,
      "disabled": _vm.disableSearchButton
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1238adbf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1238adbf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/duplicateMovementsAnalysis/duplicateMovements.pug
// module id = 1368
// module chunks = 0